import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    //@observable sent = false;
    @observable error = false;

    submitSignature(sig) {
        if(utils.getID() === null) {
            return;
        }
        
        return axios.post(utils.getMsgUrl('sendService'), {
            clientId: utils.getSendPrefix() + utils.getID(),
            event: "submitSignature",
            payload: {
                tacsignature: sig
            }
        })
        /*.then((resp) => {
            this.sent = true;
        })
        .catch((error) => {
            this.error = true;
        })*/
    }
}
var SignatureStore = new store;
export default SignatureStore;


// WEBPACK FOOTER //
// ./src/js/stores/SignatureStore.js